var path = 'areas/shared/views/artifact-listing.html';
var html = "<div> <p class=\"tutorial pad-text\" ng-show=!artifacts.Items.length> No artifacts have been added. Learn more about collecting artifacts <a href=http://g.octopushq.com/Artifacts target=_blank>here</a>. </p> <ul ng-show=artifacts class=file-list> <li ng-repeat=\"artifact in artifacts.Items\" class=\"ext-{{ artifact.Filename | extension }}\"> <a href=\"{{ formatDownload(artifact) }}\">{{ artifact.Filename }}</a> <span class=gray ng-show=artifact.Source>({{ artifact.Source }})</span> </li> </ul> <octo-paginator collection=artifacts></octo-paginator> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/artifact-listing.html
// module id = 958
// module chunks = 1